import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadSwitch2 = () => {
    const promiseSwitch2 = new Promise((resolve, reject) => {
        loader.load(
            "office/model/switch2/switch2.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(1.623338358242044,1.3655355391389048,4.3136690193713045);
                model.scale.set(0.17, 0.17, 0.17);
                model.rotation.set(-0.21194211335650562,0.18844849656383975,0.04028775924492588);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseSwitch2;
};

export { loadSwitch2 };
